import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import AI_PRODUCTS from '../data/aiProducts';

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const fadeUpDelayed = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.1 } },
};

const cardContainerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const SectionEyebrow = ({ label }) => (
  <div className="svc-eyebrow products-eyebrow">
    <span className="svc-eyebrow-line" />
    <span className="svc-eyebrow-text">{label}</span>
    <span className="svc-eyebrow-line" />
  </div>
);

const ProductCard = ({ product, index }) => (
  <motion.div
    className={`ai-product-col ai-card--${index + 1}`}
    variants={cardVariants}
  >
    <h3 className="ai-card-name">
      <Link to={`/products/${product.slug}`} className="product-card-link">
        {product.name}
      </Link>
    </h3>
    <p className="ai-card-desc">{product.desc}</p>
    {product.externalUrl && (
      <a
        href={product.externalUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="product-card-external-link"
      >
        {product.externalLabel || 'Visit product'}
      </a>
    )}
    <Link to={`/products/${product.slug}`} className="product-card-media-link">
      <div className="ai-card-media">
        <div className="ai-card-chrome">
          <span className="ai-chrome-dot ai-chrome-dot--r" />
          <span className="ai-chrome-dot ai-chrome-dot--y" />
          <span className="ai-chrome-dot ai-chrome-dot--g" />
        </div>
        <img src={product.gif} alt={product.name} className="ai-card-gif" />
      </div>
    </Link>
  </motion.div>
);

const ProductsSection = () => {
  const sectionRef = useRef(null);
  const inView = useInView(sectionRef, { once: true, margin: '-80px' });

  return (
    <section id="products" className="products-section" ref={sectionRef}>
      <div className="container">
        <motion.div
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          variants={fadeUp}
        >
          <SectionEyebrow label="Our Products" />
        </motion.div>

        <motion.div
          className="ai-solutions-section"
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          variants={fadeUpDelayed}
        >
          <div className="ai-solutions-header">
            <h2 className="svc-heading products-heading">Our AI Solutions</h2>
            <p className="svc-subtext products-subtext">
              Products built with intelligence. Focused AI tools that solve specific problems-ready to deploy, easy to integrate.
            </p>
          </div>

          <motion.div
            className="ai-solutions-grid"
            variants={cardContainerVariants}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
          >
            {AI_PRODUCTS.map((product, i) => (
              <ProductCard key={product.name} product={product} index={i} />
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default ProductsSection;
